import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import Home from "./pages/Home";
import LandingPage from "./pages/LandingPage";
import NewCase from "./pages/NewCase";
import CaseView from "./pages/CaseView";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Pricing from "./pages/Pricing";
import Redeem from "./pages/Redeem";
import AdminGrants from "./pages/AdminGrants";
import { CallShieldAlert } from "./components/CallShieldAlert";
import "@fontsource/source-serif-4";

// Wrapper that requires authentication
function ProtectedLayout() {
  return (
    <>
      <SignedIn>
        <CallShieldAlert />
        <Outlet />
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}

// Root route: landing page for visitors, home dashboard for signed-in users
function RootPage() {
  return (
    <>
      <SignedIn>
        <CallShieldAlert />
        <Home />
      </SignedIn>
      <SignedOut>
        <LandingPage />
      </SignedOut>
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Root — landing page or home dashboard depending on auth state */}
        <Route path="/" element={<RootPage />} />

        {/* Public routes — accessible without authentication */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/try" element={<NewCase />} />
        <Route path="/r/:code" element={<Redeem />} />

        {/* Protected routes — require sign-in */}
        <Route element={<ProtectedLayout />}>
          <Route path="/new" element={<NewCase />} />
          <Route path="/case/:id" element={<CaseView />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/grants" element={<AdminGrants />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
